import { useRef, useState, useLayoutEffect, useCallback } from 'react'
import { TIMELINE_RULER_SLICE_WIDTH } from 'consts'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'

export const useRulerBreakpointsCount = () => {
  const [breakpointsCount, setBreakpointsCount] = useState(0)

  const rulerRef = useRef<HTMLDivElement>(null)
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )

  const calculateBreakpointsCount = useCallback(() => {
    const element = rulerRef.current
    if (!element) return
    const width = element.getBoundingClientRect().width
    setBreakpointsCount(Math.ceil(width / TIMELINE_RULER_SLICE_WIDTH))
  }, [])

  useLayoutEffect(() => {
    const element = rulerRef.current
    if (!element) return

    const resizeObserver = new ResizeObserver(() => {
      calculateBreakpointsCount()
    })

    resizeObserver.observe(element)
    calculateBreakpointsCount()

    return () => resizeObserver.disconnect()
  }, [calculateBreakpointsCount])

  return {
    rulerRef,
    breakpointsCount,
    timelineRulerSliceDuration
  }
}
